@let showError = inputFormControl().invalid && isSubmitted();
<div class="d-flex flex-column gap-1">
  <label class="form-input-label" [for]="inputId" [hidden]="!label()">{{ label() }}</label>
  <lib-file-upload-input
    [multiple]="multiple()"
    [accept]="accept()"
    [error]="showError"
    [formControl]="inputFormControl()"
    [description]="description()"
    [controlId]="inputId"
    [showCropDialog]="showCropDialog()"
    [singleFileOnlyError]="singleFileOnlyError()">
  </lib-file-upload-input>
  @if (hintText()) {
    <div class="form-input-hint-label" [class.disabled]="inputFormControl().disabled">
      {{ hintText() }}
    </div>
  }
  @if (showError) {
    <lib-form-error [errors]="inputFormControl().errors"></lib-form-error>
  }
</div>
